import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IHideForBrand, EBrands } from 'src/app/domain/interfaces/views/interface-hide-for-brand';

@Injectable({
  providedIn: 'root'
})
export class HideForBrandsService {
  private PFIVerify = new BehaviorSubject<IHideForBrand>({
    hide: false
  });

  private GetPFIVerify = new BehaviorSubject<IHideForBrand>({
    hide: false
  });

  private Financeify = new BehaviorSubject<IHideForBrand>({
    hide: false
  });

  private GetFinanceify = new BehaviorSubject<IHideForBrand>({
    hide: false
  });

  private Finsights = new BehaviorSubject<IHideForBrand>({
    hide: false
  });

  private PFISimplify = new BehaviorSubject<IHideForBrand>({
    hide: false
  });

  private PFIVerifyDOVentures = new BehaviorSubject<IHideForBrand>({
    hide: false
  });

  private MyFinanceifyDOVentures = new BehaviorSubject<IHideForBrand>({
    hide: false
  });

  private FinancialInsight = new BehaviorSubject<IHideForBrand>({
    hide: false
  });

  currenthideForBrandPFIVerify = this.PFIVerify.asObservable();
  currenthideForBrandGetPFIVerify = this.GetPFIVerify.asObservable();
  currenthideForBrandFinanceify = this.Financeify.asObservable();
  currenthideForBrandGetFinanceify = this.GetFinanceify.asObservable();
  currenthideForBrandFinsights = this.Finsights.asObservable();
  currenthideForBrandPFISimplify = this.PFISimplify.asObservable();
  currenthideForBrandPFIVerifyDOVentures = this.PFIVerifyDOVentures.asObservable();
  currenthideForBrandMyFinanceifyDOVentures = this.MyFinanceifyDOVentures.asObservable();
  currenthideForBrandFinancialInsight = this.FinancialInsight.asObservable();

  constructor() { }


  getHideForBrands(brands: string[]) {
    return brands.includes(window.location.host);
  }

  setHideForBrand(hideBrand: string) {
    switch (hideBrand) {
      case EBrands.PFIVerify: {
        this.PFIVerify.next({ hide: true });
        break;
      }
      case EBrands.GetPFIVerify: {
        this.PFIVerify.next({ hide: true });
        break;
      }
      case EBrands.Financeify: {
        this.Financeify.next({ hide: true });
        break;
      }
      case EBrands.GetFinanceify: {
        this.GetFinanceify.next({ hide: true });
        break;
      }
      case EBrands.Finsights: {
        this.Finsights.next({ hide: true });
        break;
      }
      case EBrands.PFISimplify: {
        this.PFISimplify.next({ hide: true });
        break;
      }
      case EBrands.PFIVerifyDOVentures: {
        this.PFIVerifyDOVentures.next({ hide: true });
        break;
      }
      case EBrands.MyFinanceifyDOVentures: {
        this.MyFinanceifyDOVentures.next({ hide: true });
        break;
      }
      case EBrands.FinancialInsight: {
        this.FinancialInsight.next({ hide: true });
        break;
      }
    }
  }
}
